import { ClientLoginSetting } from "api/users";

export const mapClientLoginSettings = (
  settings: ClientLoginSetting[]
): MappedClientLoginSettings[] =>
  settings.map(mapSetting).sort((a, b) => a.order - b.order);

const mapSetting = (
  settings: ClientLoginSetting
): MappedClientLoginSettings => {
  switch (settings.typeId) {
    // Password
    case 1:
      return { ...settings, order: 1, restricted: false };
    // Single Sign On
    case 4:
      return { ...settings, order: 2, restricted: true };
    default:
      return { ...settings, order: 3, restricted: false };
  }
};

export type MappedClientLoginSettings = ClientLoginSetting & {
  order: number;
  restricted: boolean;
};
